import { getBaseUrl } from '@shared';

export function clientUserSignInLinkByEmail(
  clientEmail?: string,
  redirectTo: string = '/client/home',
): string {
  if (!clientEmail) return `${getBaseUrl()}/client/login`;
  const params = new URLSearchParams({
    email: clientEmail,
    redirect_to: redirectTo,
  });
  return `${getBaseUrl()}/client/login?${params.toString()}`;
}
